module.exports = __webpack_public_path__ + "img/diffusion_annonces.28ae52cd.png";